import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";

const team = [
  {
    name: "Joe Del Balso",
    role: "CO-FOUNDER & CEO",
    image:
      "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/6tp1r97c_TakeOff_TEAM-2%20%281%29.jpg",
    bio: "Visionary leader with a passion for scaling brands through innovative marketing strategies and systems.",
  },
  {
    name: "Michael Franceschini",
    role: "CO-FOUNDER & CMO",
    image:
      "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/0h8b3qq3_TakeOff_TEAM-7.jpg",
    bio: "Creative strategist driving content excellence and brand storytelling that converts audiences into customers.",
  },
];

export default function Team() {
  return (
    <section
      data-testid="team-section"
      className="py-24 md:py-32 bg-dark-secondary"
    >
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            data-testid="team-title"
            className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl uppercase text-white"
          >
            Meet The <span className="text-lime">Team</span>
          </h2>
          <p className="font-body text-white/60 mt-4 max-w-xl mx-auto">
            The minds behind TAKEOFF Marketing Group.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`team-member-${index}`}
              className="bg-dark-card border border-white/5 overflow-hidden group hover:border-lime/30 transition-all duration-300"
            >
              {/* Image */}
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500"
                />
              </div>

              {/* Info */}
              <div className="p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="font-heading font-bold text-xl uppercase text-white">
                      {member.name}
                    </h3>
                    <p className="font-body text-sm text-lime mt-1">
                      {member.role}
                    </p>
                  </div>
                  <button
                    data-testid={`linkedin-${index}`}
                    className="w-10 h-10 bg-dark-secondary border border-white/10 flex items-center justify-center hover:bg-lime hover:text-black transition-all duration-300"
                  >
                    <Linkedin className="w-4 h-4" />
                  </button>
                </div>
                <p className="font-body text-sm text-white/60 mt-4 leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
